import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appIncrement]',
  standalone: true,
})
export class IncrementDirective {
  @Input() duration: number = 1000;
  @Input() iterations: number = 30;

  private intervalId: any;

  constructor(private elementRef: ElementRef) {}

  startAnimation() {
    let count: number = 0;
    const value: number = parseFloat(this.elementRef.nativeElement.textContent);
    const iterationValue: number = value / this.iterations;
    this.stopAnimation();
    this.intervalId = setInterval(() => {
      this.elementRef.nativeElement.innerText = (
        count * iterationValue
      ).toFixed(0);
      count++;
      if (count > this.iterations) this.stopAnimation();
    }, this.duration / this.iterations);
  }

  stopAnimation() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  ngAfterViewInit(): void {
    const element: HTMLElement = this.elementRef.nativeElement;

    if (
      element &&
      element.textContent &&
      !Number.isNaN(parseFloat(element.textContent))
    ) {
      this.startAnimation();
    } else {
      throw console.error('not value on this element.');
    }
  }

  ngOnDestroy() {
    this.stopAnimation();
  }
}
